import { __decorate } from "tslib";
import { LitElement, html, css } from 'lit';
import { customElement, property } from 'lit/decorators.js';
import { elements } from './sdb-elements.js';
/**
 * Summaryitem element, used for each individual summaryitem within the summary element
 *
 * @prop {String} headline (part) - used to define the main headline of the summaryitem
 * @prop {String} icon - optional, used to dislpay a Fontawesome icon
 * @prop {Boolean} darkText - optional, used to dislpay the text in a dark color
 *
 * @lsot - unnamed slot (default)
 *
 */
let SDBContentSummaryItem = class SDBContentSummaryItem extends LitElement {
    constructor() {
        super(...arguments);
        this.headline = '';
        this.icon = '';
        this.darkText = false;
    }
    render() {
        return html `
            <!-- Listitem images yes/no -->
            ${this.icon
            ? html `
                      <div class="summaryItemIconWrapper">
                          <div class="summaryItemIcon">
                              <sdb-content-icon
                                  size="20"
                                  .icon=${this.icon}
                              ></sdb-content-icon>
                          </div>
                      </div>
                  `
            : html ``}

            <div class="summaryItemContent">
                ${this.headline
            ? html `<div class="headline" part="headline">
                          ${this.headline}
                      </div>`
            : html ``}
                <slot name="button" class="summaryItemButton"></slot>
                <div class="content" part="content"><slot></slot></div>
            </div>
        `;
    }
};
SDBContentSummaryItem.styles = [
    elements,
    css `
            :host {
                height: auto;
                padding: 15px 40px 15px 15px;
                display: grid;
                grid-template-rows: 1fr; /* rows will use full available height */
                grid-template-columns: auto 1fr; /* auto makes sure image column is not displayed if no image is used */
                border-right: 1px solid rgba(255, 255, 255, 0.5);
                grid-template-areas: 'icon content';
            }

            :host(:last-of-type) {
                border: none;
            }

            @media only screen and (max-width: 767px) {
                /* For mobile phones: */
                :host {
                    border-right: none;
                    border-bottom: 1px solid rgba(255, 255, 255, 0.5);
                    padding: 15px 0;
                }
            }

            .summaryItemIconWrapper {
                grid-area: icon;
                display: flex;
                justify-content: center;
                align-items: start;
            }

            .summaryItemIcon {
                width: 25px;
                height: 25px;
                margin: 2px 15px 0 0;
                color: var(--text-light);
                background-size: contain;
                background-color: #f6f6f6; /* fallback if no image is set*/
                background: transparent;
                display: flex;
                justify-content: center;
                align-items: center;
            }

            .summaryItemButton {
                position: absolute;
                display: block;
                top: 0;
                right: 0;
                width: 25px !important;
                height: 25px;
            }

            .headline {
                height: 25px;
                padding-top: 2px;
                font-weight: 400;
            }

            .summaryItemContent {
                grid-area: content;
                display: flex;
                flex-direction: column;
                justify-content: flex-start; /* makes sure the content is left aligned */
                align-items: stretch; /* makes sure the items use the full available height of the row */
                color: var(--text-light);
                position: relative;
            }

            :host([darkText]) .summaryItemIcon {
                color: var(--text-dark);
            }

            :host([darkText]) .summaryItemContent {
                color: var(--text-dark);
            }

            .summaryItemContent > * {
                /* makes sure all the optional items use the full width of the listitem content wrapper */
                width: 100%;
            }
        `,
];
__decorate([
    property({ type: String })
], SDBContentSummaryItem.prototype, "headline", void 0);
__decorate([
    property({ type: String })
], SDBContentSummaryItem.prototype, "icon", void 0);
__decorate([
    property({ type: Boolean })
], SDBContentSummaryItem.prototype, "darkText", void 0);
SDBContentSummaryItem = __decorate([
    customElement('sdb-content-summaryitem')
], SDBContentSummaryItem);
export { SDBContentSummaryItem };
//# sourceMappingURL=sdb-content-summaryitem.js.map